
import createIconComponent from '../utils/createIconComponent';
import { SVG_TRASH_OUTLINED } from '../../../dist';
import React from 'react';
const TrashOutlinedIcon = createIconComponent({ content: SVG_TRASH_OUTLINED, height: 24, width: 24 });
TrashOutlinedIcon.displayName = 'TrashOutlinedIcon';
export default TrashOutlinedIcon;
